/**
 * Register existing WordPress core blocks for use in the form builder.
 *
 * This file provides a way to selectively register core Gutenberg blocks
 * that are useful for the giveaway form builder.
 */

const { registerBlockType, getBlockTypes, unregisterBlockType } = wp.blocks;

/**
 * List of allowed core blocks for the form builder.
 * Add block names here to make them available in the form builder.
 */
const ALLOWED_CORE_BLOCKS = [
	'core/paragraph',
	'core/heading',
	'core/image',
	'core/separator',
	'core/spacer',
	'core/columns',
	'core/column',
	'core/group',
	'core/html',
];

/**
 * Register core blocks that are allowed in the form builder.
 * This function should be called after WordPress core blocks are loaded.
 *
 * @param {Array} allowedBlocks - Optional array of block names to allow. Defaults to ALLOWED_CORE_BLOCKS.
 */
export function registerAllowedCoreBlocks( allowedBlocks = ALLOWED_CORE_BLOCKS ) {
	// Core blocks are typically already registered by WordPress.
	// This function serves as documentation and can be extended
	// to filter or modify blocks as needed.
	return allowedBlocks;
}

/**
 * Get the list of allowed core blocks.
 *
 * @return {Array} Array of allowed block names.
 */
export function getAllowedCoreBlocks() {
	return [ ...ALLOWED_CORE_BLOCKS ];
}

/**
 * Check if a block is allowed in the form builder.
 *
 * @param {string} blockName - The block name to check.
 * @return {boolean} True if the block is allowed.
 */
export function isBlockAllowed( blockName ) {
	// Allow all giveasap blocks
	if ( blockName.startsWith( 'giveasap/' ) ) {
		return true;
	}
	return ALLOWED_CORE_BLOCKS.includes( blockName );
}

/**
 * Filter registered blocks to only include allowed blocks.
 * Useful for restricting the block inserter.
 *
 * @return {Array} Array of allowed block types.
 */
export function getFilteredBlockTypes() {
	const allBlocks = getBlockTypes();
	return allBlocks.filter( ( block ) => isBlockAllowed( block.name ) );
}

export default {
	ALLOWED_CORE_BLOCKS,
	registerAllowedCoreBlocks,
	getAllowedCoreBlocks,
	isBlockAllowed,
	getFilteredBlockTypes,
};
